/**
 * Run work only after the browser has actually painted.
 *
 * For state changes that must be SEEN before something blocks the main
 * thread. Setting state and doing the work in the same tick means React
 * commits and the freeze land in one frame — the user never sees the
 * spinner, only the stall (2026-08-24 LUAT, closing an AR session).
 *
 * Two frames, not one: the first callback fires BEFORE the paint of the
 * frame it belongs to, so work scheduled there still beats the pixels
 * to the screen. The second lands after that paint has happened.
 *
 * `schedule` is injectable so this is testable without a real frame
 * loop, and so a caller without rAF (a hidden tab, where rAF never
 * fires) can pass a timeout instead.
 */
export function afterNextPaint(
  run: () => void,
  schedule: (callback: () => void) => void = (callback) => {
    requestAnimationFrame(() => callback())
  },
): void {
  schedule(() => {
    schedule(run)
  })
}
